
import { Component, Mixins } from "vue-property-decorator";
import { default as WorkflowCommonMixin } from "./WorkflowCommonMixin.vue";
import { WorkflowDocumentKinds } from "../../../domain/workflow/kinds";
import { ReceptionEditor } from "../../../domain/workflow/editor";
import { FormatReference } from "../../../domain/format";


@Component({
})
export default class ReceptionViewBaseMixin extends Mixins(WorkflowCommonMixin) {

  navigateRequestSheetEditor(reception: ReceptionEditor, format: FormatReference): void {
    // 依頼書作成画面に遷移
    const route = this.createRequestSheetRoute(reception, format);
    this.$router.replace(route);
  }

  showRequestSheetEditor(reception: ReceptionEditor, format: FormatReference): void {
    // 依頼書作成画面を開く
    const route = this.createRequestSheetRoute(reception, format);
    this.$openWindow(route.path, route.query);
  }

  private createRequestSheetRoute(reception: ReceptionEditor, format: FormatReference): any {
    return {
      path: "EditNewWorkflowDocument",
      query: {
        documentKind: WorkflowDocumentKinds.RequestSheet.toString(),
        receptionId: reception.reception.id.toString(),
        formatId: format.id.toString(),
        patientNo: reception.reception.patientInfo.patient.id,
      }
    };
  }
}
